import {ReactNode} from "react";

// Части текста, заключённые в ** как в markdown, выделяем жирным
const BOLD_PATTERN = /\*\*(.+?)\*\*/g;

/**
 * Преобразует **текст** в <strong>текст</strong>.
 * Если разметки нет, возвращает исходную строку без изменений.
 */
export function formatBoldText(text?: string | null): ReactNode {
    if (!text || !text.includes('**')) {
        return text;
    }

    const parts: ReactNode[] = [];
    let lastIndex = 0;
    let match: RegExpExecArray | null;

    BOLD_PATTERN.lastIndex = 0;
    while ((match = BOLD_PATTERN.exec(text)) !== null) {
        parts.push(text.substring(lastIndex, match.index));
        parts.push(<strong key={match.index}>{match[1]}</strong>);
        lastIndex = match.index + match[0].length;
    }

    parts.push(text.substring(lastIndex));

    return <>{parts}</>;
}

/**
 * Убирает ** из текста. Нужно там, где markdown отрисовать нельзя:
 * title страницы, meta-теги, alt, аналитика.
 */
export function stripBoldMarkers(text?: string | null): string {
    if (!text) {
        return '';
    }

    return text.replace(BOLD_PATTERN, '$1');
}
